import CustomLayout from '../../components/CustomLayout'
import Book from '../../components/reader/Book'
import {updateCloudinaryUrl} from '../../helpers/Cloudinary'

import { callApiFromServer } from '../../helpers/Api';

function BookPage(props) {
    return (
        <CustomLayout
            title={props.storyData.title}
            description={props.storyData.description}
            image={updateCloudinaryUrl(props.storyData.cover)}
            expandSiderInstantly={true}
        >
            <Book
                {...props}
            />
        </CustomLayout>
    )
}

// This gets called on every request
export async function getServerSideProps(context) {
    const {params} = context;

    if( !params || !params.story) {
        context.res.writeHead(302, { Location: '/404' });
        context.res.end();
    }

    var urlTitle = '';
    if(params.story.length >= 2) {
        urlTitle = params.story[1]
    }

    var role = 'public';
    if(params.story.length >= 3 && params.story[2] === 'admin') {
        role = 'owner'
    }

    var commentId = null;
    if(params.story.length >= 4) {
        commentId = params.story[3]
    }

    const data = await callApiFromServer(context, '/api/story/book/' + params.story[0])

    if(!data || data.length === 0) {
        context.res.writeHead(302, { Location: '/404' });
        context.res.end();
    }

    // Pass data to the page via props
    return { props: { storyData: data[0], urlTitle, admin: role === 'owner', role, commentId} }
}

export default BookPage;